export default () => {
  return {
    user: [],
  };
};
